import CloseIcon from '@mui/icons-material/Close';
import { Timeline } from '@mui/lab';
import { Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';

import SurveillanceValues from '../SurveillanceValues/SurveillanceValues';
import i18n from 'FRONTEND/utils/i18n';

const SurveillanceHistoryModal = ({ isModalOpen, handleClose, surveillanceData, currentForm, medicineList }) => {
  const sortedSurveillanceHistory = useMemo(() => surveillanceData.modificationHistory.toSorted((a, b) => a.modificationDate > b.modificationDate ? -1 : a.modificationDate < b.modificationDate ? 1 : 0), [surveillanceData.modificationHistory]);


  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='customized-dialog-title'
      open={isModalOpen}
      maxWidth='xl'
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography sx={{ fontSize: '18px' }}>{i18n._('Change history')}</Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Stack sx={{ overflow: 'auto', scrollbarWidth: 0, alignItems: 'flex-start' }}>
          <Timeline>
            {sortedSurveillanceHistory.map((surveillanceModification, index) => (
              <List key={index} sx={{ width: '100%' }}>
                <ListItem sx={{ display: 'flex', flexDirection: 'row', gap: 1, textWrapMode: 'nowrap' }}>
                  <Typography>{dayjs(surveillanceModification.modificationDate).format('HH:mm')}</Typography>
                  <Typography> {i18n._('modified By')} {surveillanceModification.modifiedBy.firstName} {surveillanceModification.modifiedBy.lastName}</Typography>
                  <Stack>
                    <SurveillanceValues
                      surveillanceEvent={surveillanceData}
                      surveillanceEventHistory={surveillanceModification}
                      currentForm={currentForm}
                      medicineList={medicineList}
                    />
                  </Stack>
                </ListItem>
              </List>
            ))}
          </Timeline>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SurveillanceHistoryModal;
